import { utcToZonedDateString, utcToZonedTimeString } from '@shared/time';
import { STUDIO_TIME_ZONE } from '../../lib/calendarRange';

/**
 * İmza tarihi etiketi — "30.09.2026 14:05" (stüdyo saati).
 *
 * Bir onay kaydında gün, ay, YIL ve saat birlikte okunmalı; takvimdeki kısa
 * gün etiketleri ("30 Eyl Çar") yılı söylemiyor. Dönüşüm `shared/time.ts`
 * içinde; burada yalnızca sıralama değişiyor.
 */
export function formatSignatureInstant(isoInstant: string): string {
  const instant = new Date(isoInstant);
  if (Number.isNaN(instant.getTime())) return isoInstant;
  return `${formatSignatureDay(utcToZonedDateString(instant, STUDIO_TIME_ZONE))} ${utcToZonedTimeString(
    instant,
    STUDIO_TIME_ZONE,
  )}`;
}

/** "YYYY-MM-DD" → "DD.MM.YYYY". */
export function formatSignatureDay(isoDate: string): string {
  const [year, month, day] = isoDate.split('-');
  if (year === undefined || month === undefined || day === undefined) return isoDate;
  return `${day}.${month}.${year}`;
}
